module.exports = __webpack_public_path__ + "static/media/western-sm.505b7c55.svg";